import { render } from "./SimilarArticles.vue?vue&type=template&id=72ce719c&scoped=true"
import script from "./SimilarArticles.vue?vue&type=script&lang=js"
export * from "./SimilarArticles.vue?vue&type=script&lang=js"

import "./SimilarArticles.vue?vue&type=style&index=0&id=72ce719c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ce719c"]])

export default __exports__